import * as _DossierTileHeadline from './TileHeadline'

export const DossierTileHeadline = { ..._DossierTileHeadline }

export { default as TeaserFrontDossier } from './Teaser'
export { default as TeaserFrontDossierIntro } from './TeaserIntro'
export { default as TeaserFrontDossierHeadline } from './Headline'
export { default as TeaserFrontDossierLead } from './Lead'
export { default as TeaserFrontDossierMore } from './More'

export { default as DossierTag } from './Tag'
export { default as DossierSubheader } from './Subheader'
